var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2V8.025V8V18V2ZM2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H10L16 6V8.5C15.6833 8.36667 15.3583 8.2625 15.025 8.1875C14.6917 8.1125 14.35 8.05833 14 8.025V7H9V2H2V18H8.025C8.29167 18.4 8.59167 18.7708 8.925 19.1125C9.25833 19.4542 9.625 19.75 10.025 20H2Z",
    fill: "#587E85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 19.5C12.1167 19.5 10.9375 19.0125 9.9625 18.0375C8.9875 17.0625 8.5 15.8833 8.5 14.5C8.5 13.1167 8.9875 11.9375 9.9625 10.9625C10.9375 9.9875 12.1167 9.5 13.5 9.5C14.8833 9.5 16.0625 9.9875 17.0375 10.9625C18.0125 11.9375 18.5 13.1167 18.5 14.5C18.5 15.8833 18.0125 17.0625 17.0375 18.0375C16.0625 19.0125 14.8833 19.5 13.5 19.5ZM14 14.3V11.5H13V14.7L15.15 16.85L15.85 16.15L14 14.3Z",
    fill: "#587E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentSearch);
export default __webpack_public_path__ + "static/media/document_search.e54e41ad691213dae67a9e92d740cd91.svg";
export { ForwardRef as ReactComponent };